import theme from '../../theme/theme';

const {
  colors: { gray_icon },
} = theme;

const styles = {
  wrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    height: '8vh',
    paddingLeft: '8%',
    paddingRight: '8%',
  },

  title: {
    display: 'flex',
    flexBasis: '50%',
    margin: 'auto 0',
  },

  clipboard: {
    color: gray_icon,
    flexBasis: '25%',
    margin: 'auto 0',
  },

  arrrow: {
    flexBasis: '25%',
    margin: 'auto 0',
  },
};

export default styles;
